import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';

import { useCallback } from 'react';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { InfoIcon } from 'ui-components/components/info-icon';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from '../messages';
import style from '../style.module.less';

export const PortalUrlSection = ({ portalUrl, loadingText = 'Loading portal URL...', isCompact = false, onCopyUrl = noop }) => {
  const intl = useIntl();

  const handleCopyUrl = useCallback(() => {
    if (portalUrl && typeof portalUrl === 'string') {
      navigator.clipboard.writeText(portalUrl);
      onCopyUrl();
    }
  }, [portalUrl, onCopyUrl]);

  const errorMessage = intl.formatMessage(messages.portalUrlLoadError);
  let displayText;
  let isButtonDisabled;

  if (portalUrl === undefined) {
    displayText = loadingText;
    isButtonDisabled = true;
  } else if (portalUrl === null || portalUrl === errorMessage) {
    displayText = errorMessage;
    isButtonDisabled = true;
  } else {
    displayText = portalUrl;
    isButtonDisabled = false;
  }

  if (isCompact) {
    return (
      <FlexRow className={style['returns-step-portal-url-box']}>
        <Text className={style['returns-step-portal-url-link']} textType={TextType.Paragraph} value={displayText} />
        {!isButtonDisabled && (
          <Button ariaLabel={intl.formatMessage(messages.copyPortalUrl)} onClick={handleCopyUrl} theme={THEME_CONSTANTS.unstyled}>
            <FontAwesomeIcon className={style['returns-step-copy-icon']} icon={faCopy} />
          </Button>
        )}
      </FlexRow>
    );
  }

  return (
    <FlexRow className={style['returns-step-portal-row']}>
      <FlexRow className={style['returns-step-portal-label-with-icon']}>
        <Text className={style['returns-step-portal-label']} textType={TextType.Paragraph} value={messages.customerPortalUrl} />
        <InfoIcon
          className={style['returns-step-portal-info-icon']}
          color={THEME_CONSTANTS.unstyled}
          icon={faQuestionCircle}
          tooltipText={<Text textType={TextType.Paragraph} value={messages.customerPortalUrl} />}
        />
      </FlexRow>
      <FlexRow className={style['returns-step-portal-url-container']}>
        <Text textType={TextType.Paragraph} value={displayText} />
        {!isButtonDisabled && (
          <Button onClick={handleCopyUrl} theme='link'>
            <FontAwesomeIcon className={style['returns-step-copy-icon']} icon={faCopy} />
          </Button>
        )}
      </FlexRow>
    </FlexRow>
  );
};
